import simpleParallax from 'simple-parallax-js';

const directions = [
	"up",
	"down",
	"left",
	"right",
	"up left",
	"up right",
	"down left",
	"down right",
];

const init = () => {
	directions.forEach((direction) => {
		new simpleParallax(
			document.getElementsByClassName(
				"parallax-" + direction.replace(/\s+/g, "-")
			),
			{
				delay: 3,
				scale: 2.5,
				transition: "cubic-bezier(0,0,0,1)",
				overflow: true,
				orientation: direction,
			}
		);
	});
};

const parallax = {
	init: init,
};

export default parallax;
